import { SEARCH_CITIES } from "../../../../Utils/AllPagesQuriesAndMutations";



const TollAndFuelCalculatorConfig = [
    {
        name: "Toll_And_Fuel_Calculator_Details",
        fields: [
            {
                id: Math.random() * 10,
                name: "From_City",
                label: "From City",
                masterName: "City_Search",
                type: "InputDropForQuery",
                dropdowncontent: SEARCH_CITIES,
                min: 2,
                max: Infinity,
                isRequired: true,
            },
            {
                id: Math.random() * 10,
                name: "To_City",
                label: "To City",
                masterName: "City_Search",
                type: "InputDropForQuery",
                dropdowncontent: SEARCH_CITIES,
                min: 2,
                max: Infinity,
                isRequired: true,
            },
            {
                id: Math.random() * 10,
                name: "vehicle_Type",
                type: "select",
                dropdowncontent: ["2AxlesTruck", "3AxlesTruck", "4AxlesTruck", "5AxlesTruck", "6AxlesTruck", "7AxlesTruck"],
                min: 2,
                max: Infinity,
                isRequired: true,
            }
        ],
    },
];

export { TollAndFuelCalculatorConfig };
